// extracted by mini-css-extract-plugin
module.exports = {"financialSummary":"RefundSummary_financialSummary__3eoZ0","title":"RefundSummary_title__3NxSY"};